import { Reducer } from "redux";
import { SET_AVAILABLE_WORKERS, SET_QUEUED_TIMESTAMPS } from "../actions/appInfoActions";

export interface IWorkerInfo {
    applications: IWorkerApplication[];
    hostname: string;
    ipAddress: string;
    workerName: string;
}

export interface IWorkerApplication {
    name: string;
    isRunning: boolean;
}

export interface AppInfoState {
    queuedTimestamps: number;
    availableWorkers: number;
}

const initialState: AppInfoState = {
    queuedTimestamps: 0,
    availableWorkers: 0,
};

export const appInfoReducer: Reducer<AppInfoState> = (
    state: AppInfoState = initialState,
    action: any
): AppInfoState => {
    switch (action.type) {
        case SET_QUEUED_TIMESTAMPS:
            return { ...state, queuedTimestamps: action.value };
        case SET_AVAILABLE_WORKERS:
            return { ...state, availableWorkers: action.value };
        default:
            return state;
    }
};
